<ng-container *transloco="let t; read: 'multi-search-filter'">
  <div *ngIf="label"
    class="label font-normal-semibold">
    <span>{{ label }}
      <accredible-chip *ngIf="selectedOptions.length > 0"
        [data]="selectedOptions.length.toString()"
        [color]="'primary'"
        [size]="'small'"
        (remove)="onRemoveAllOptions()">
      </accredible-chip>
    </span>
  </div>

  <div class="input-container"
    #searchInputContainerElement
    [hidden]="hideSearchInput"
    [ngClass]="{ 'input-focused': inputFocused, 'cdk-keyboard-focused': cdkKeyboardFocused }">
    <div class="chips-container"
      (click)="searchInputElement.focus()">
      <ng-container *ngFor="let el of selectedOptions; let i = index">
        <accredible-chip [data]="el[optionsLabelKey]"
          [size]="'small'"
          [img]="el[optionsImgKey]"
          [tabIndexRemove]="-1"
          (remove)="onRemoveOption(el)">
        </accredible-chip>
      </ng-container>

      <input #searchInputElement
        class="font-normal-regular"
        type="text"
        [attr.data-cy]="'input-'+dataCy"
        [ngModel]="searchQueryNgModel"
        [placeholder]="selectedOptions.length > 0 ? '' : placeholder"
        (ngModelChange)="onSearchQueryChange($event.trim())"
        (focus)="setInputKeyboardFocus($event, true)"
        (blur)="setInputKeyboardFocus($event, false)">

      <div #searchInputCopyElement
        class="input-copy-element">
      </div>
    </div>

    <div *ngIf="isInMenu && selectedOptions.length > 0"
      class="btn-remove-all-container">
      <accredible-icon role="button"
        [icon]="'error'"
        (click)="onRemoveAllOptions()">
      </accredible-icon>
    </div>
  </div>

  <div class="scroll-wrapper"
    [class.bottom-gradient]="showBottomGradient">
    <div *ngIf="displayedOptions.length > 0; else noOptions"
      #scrollContainer
      class="scroll-container"
      [class.max-height]="useMaxHeight"
      (scroll)="onScroll($event.target)"
      (mouseleave)="onMouseLeaveScrollContainer()">

      <div *ngFor="let option of displayedOptions | slice:0:optionsLimit; let i = index"
        class="option"
        [attr.data-cy]="dataCy + '-option-' + i"
        [class.selected]="selectedOptionsIds.includes(option.id)"
        [class.highlighted]="option.id === highlightedOption?.id"
        [class.disabled]="boxDisabled && !selectedOptionsIds.includes(option.id)"
        (click)="toggleOption(option)"
        (mouseover)="onOptionHover(option)">
        <div class="option-checkbox">
          <accredible-icon [icon]="'check'">
          </accredible-icon>
        </div>

        <div class="option-label"
          [class.use-ellipsis]="useEllipsisOnOptions"
          [accredibleTooltip]="useEllipsisOnOptions ? option[optionsLabelKey] : null"
          [tooltipOnlyOnTruncation]="true">
          {{ option[optionsLabelKey] }}
        </div>

        <img *ngIf="option[optionsImgKey]"
          [src]="option[optionsImgKey]"
          alt=""/>
      </div>
    </div>
  </div>

  <ng-template #noOptions>
    <div class="no-options">
      {{ t('no_results') }}
    </div>
  </ng-template>
</ng-container>
